import React from 'react'
import qs from 'qs'
//import shared from '../../../../testing/students/shared'
import customRequest from '../../../../helpers/customRequest'
import { initializeFormValidation } from '../../../../helpers/forms/form-validation'
import message from '../../../../components/message/message'
import redirect from '../../../../components/redirect/redirect'
import ClipLoader from 'react-spinners/ClipLoader'

class Revoke extends React.Component
{
    state = {
        permissions: [],
        submitting: false
    }
    componentDidMount()
    {
        var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        customRequest.get('/api/students/share')
        .then(({data}) => {
            if (data.valid) {
                var shared = data.permissions
                var permissions = []
                //The format for the permissions is a bit odd so I'll attempt to explain it
                //Params should look like this:
                //{
                //  customerUsername: [student1, student2],
                //  customerUsernam2: [Ray, ...],
                //  ...
                //{
                for (var customer in params.permissions)
                {
                    var students = params.permissions[customer]
                    for (var student of students)
                    {
                        for (var permission of shared)
                        {
                            if (permission.student == student && permission.customer == customer)
                            {
                                permissions.push(permission)
                            }
                        }
                    }
                }

                this.setState({permissions: permissions})

            }
        })

        initializeFormValidation(this.onSubmit);
    }

    onSubmit = () => {
        this.setState({submitting: true}, async () =>
        {
            var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
            var promises = []
            for (var customer in params.permissions)
            {
                var students = params.permissions[customer]
                promises.push(customRequest.post('/api/students/share', {
                    students: students,
                    permissions: [],
                    shareToCustomer: customer
                }))
            }
            
            var responses = await Promise.all(promises)
            
            for (var response of responses) {
                if (response.data == false) {
                    return redirect.send('/students/share/manage', () =>
                    {
                        message.error('There has been an internal error.')
                    }) 
                }
            }

            redirect.send('/students/share/manage', () =>
            {
                message.success('Permissions have been successfully revoked.')
            })
        })
    }
    
    render()
    {
        var {permissions} = this.state
        return (
            <React.Fragment>
                <h1>Revoke Student Sharing Setting{permissions.length > 1 ? "s" : ""}</h1>
                <div class = "row subheader-text">
                    <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Please confirm revoking existing sharing settings below.</p>
                    </div>
                </div>

                <form class = "form-horizontal form-validate" noValidate method = "post">
                    <div class = "form-group row">
                        <label class = "text-center-xs bold-xs col-sm-3 control-label text-right">Setting{permissions.length > 1 ? "s" : ""}</label>
                        
                        <div class = "col-sm-6">
                            {
                                permissions.map((permission) =>
                                {
                                    var permissionName
                                    if (permission.read && permission.write)
                                        permissionName = "all"
                                    else if (permission.read)
                                        permissionName = "read"
                                    else if (permission.write)
                                        permissionName = "write"
                                    
                                    return (
                                    <React.Fragment>
                                        <p class = "form-control-static text-left text-center-xs break-words"><strong>{permission.student}</strong> shared to <strong>{permission.customer}</strong> with <strong>{permissionName}</strong> permissions</p>
                                    </React.Fragment>
                                    )
                                })
                            }
                        </div>
                    </div>
                    
                    <button type = "submit" class = "btn btn-secondary btn-lg">{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Revoke"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Revoke
